import React from 'react';
import {observer} from "mobx-react";
import {GameInfo} from '../../../../services/games/game-info';
import {VideoStreamSlidePlayerComponent} from './parts/player/video-stream-slide-player.component';
import {VideoSlideLayoutComponent} from '../../layout/video-slide-layout.component';
import {VideoSlideContentLayoutComponent} from '../../layout/content/video-slide-content-layout.component';
import {VideoSlideFooterLayoutComponent} from '../../layout/footer/video-slide-footer-layout.component';
import {IVideoPlayerViewModel} from "../../../../services/video/models/video-player.view-model.interface";
import {VideoSlideStreamFooterComponent} from '../../parts/video-slides-stream-footer/video-slides-stream-footer.component';


interface VideoStreamSlideComponentProps {
    gameInfo: GameInfo;
    videoPlayer: IVideoPlayerViewModel;
    isActive: boolean;
    onPlayGameClick: () => void;
    onBookGame: () => void;
    onRemoveBookedGame: () => void;
}

export const VideoStreamSlideComponent: React.FC<VideoStreamSlideComponentProps> = observer((props) => {
    return (
        <VideoSlideLayoutComponent showProgressIndicator={props.videoPlayer.isBuffering}>
            <VideoSlideContentLayoutComponent>
                <VideoStreamSlidePlayerComponent gameInfo={props.gameInfo} videoPlayer={props.videoPlayer} isActive={props.isActive}/>
            </VideoSlideContentLayoutComponent>
            <VideoSlideFooterLayoutComponent
                gameInfo={props.gameInfo}
                onPlayGameClick={props.onPlayGameClick}
                onBookGame={props.onBookGame}
                onRemoveBookedGame={props.onRemoveBookedGame}
                secondaryText={<VideoSlideStreamFooterComponent gameInfo={props.gameInfo} type={"bets"} />}
            />
        </VideoSlideLayoutComponent>
    )
})
